import HttpRequest from './HttpRequest'
import { getAuthToken } from '@/utils/js/Auth'
export default class UserProvider extends HttpRequest {
  getUser (query) {
    this.setHeader(getAuthToken())
    return this.get(`/users?${query}`)
  }

  getUserById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/users/${id}`)
  }

  getUserLog (id) {
    this.setHeader(getAuthToken())
    return this.get(`/users/${id}/log`)
  }

  createUser (payload) {
    this.setHeader(getAuthToken())
    return this.post(`/users`, payload)
  }

  updateUser (id, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/users/${id}`, payload)
  }

  updateUserStatus (id, payload) {
    this.setHeader(getAuthToken())
    return this.edit(`/users/${id}/status`, payload)
  }

  deleteUser (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/users?id=${id}`)
  }
}
